import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import PaymentFilter from 'components/sales/ListFilters/PaymentFilter';
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Images from "assets/images/imageData";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import AdjustAdvancePopup from "components/sales/paymentPortal/adjustAdvance/adjustAdvancePopup";
import ViewDetailsPopup from "components/sales/paymentPortal/viewDetails/viewDetails";

const InvoiceList = ({
  getPerformaInvoice,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
}) => {
  const headers = [
    "Invoice Number",
    "Invoice Date",
    "Business",
    "Revenue Nature",
    "Total Amount",
    "Due date",
    "Status",
    "Pending Amount",
    "Actions",
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);


  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales("post-sales-corporate");
      } else if (teamId && teamId === 9) {
        setActivePostSales("post-sales-supply");
      } else if (teamId && teamId === 8) {
        setActivePostSales("post-sales-apartment");
      } else {
        setActivePostSales("post-sales-b2b-alliance");
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getPerformaInvoice !== null) {
      (async () => {
        setIsLoading(true);
        await getPerformaInvoice(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getPerformaInvoice]);

  useEffect(() => {
    const tableData = [
      "id",
      "invoice_number",
      "invoice_date",
      "business",
      "revenue_nature",
      "total_amount",
      "due_date",
      "status",
      "pending_amount",
    ];

    if (postSalesList !== {} && postSalesList.resultSets) {
      const data = postSalesList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: [
              // { name: "Add Payment", businessId: element?.business_id, invoiceId: element?.invoice_id, contractId: element?.contract_id },
              // { name: "Advance Adjustment", businessId: element?.business_id, invoiceId: element?.invoice_id, contractId: element?.contract_id },
              { name: "View Detail", invoiceId: element?.invoice_id }
            ],
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getPerformaInvoice(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
         <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          {/* <img src={Images?.Filter} alt="" /> */}
          {localization.showFilters}
        </Button> 
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getPerformaInvoice(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.performaInv}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
        setShowDetailsPopup={setShowDetailsPopup}
        setCurrentInvoiceId={setCurrentInvoiceId}
      />

      <PaymentFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={"5"}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        invoiceFilters
      />

      {showDetailsPopup && <ViewDetailsPopup 
        showViewDetailsPopup={showDetailsPopup}
        onClosePopup={() => setShowDetailsPopup(false)}
        invoiceId={currentInvoiceId}
      />}
    </Layout>
  );
};

export default InvoiceList;
